import React, { PropsWithChildren, useState } from "react";
import "./NewsCard.css";

interface NewsCardProps extends PropsWithChildren {
  image?: string;
  title: string;
}
const NewsCard: React.FC<NewsCardProps> = ({
  image,
  title,
  children,
}) => {
  const [imageHasError, setImageHasError] = useState(false);

  const handleImageError = () => {
    setImageHasError(true);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignSelf: "center",
      }}
    >
      <div className="news-c-container">
        {!imageHasError && image && (
          <div className="news-c-image-section">
            <img
              src={image}
              alt={title}
              className="news-c-image"
              onError={handleImageError}
            />
          </div>
        )}

        <div className="news-c-card">
          <div className="news-c-card-decoration">
            <div className="news-c-card-circle" />
            <div className="news-c-card-line" />
          </div>

          <div className="news-c-content">
            <h2>{title}</h2>

            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsCard;
